import styled, { css } from "styled-components";

export const StyledCard = styled.div<{ $selected: boolean }>`
    border: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    border-radius: 6px;
    background-color: ${({ theme }) => theme.secondaryBackgroundColor};
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    ${({ $selected, theme }) =>
        $selected
            ? css`
                  background-color: ${theme.itemBackground};
                  border: 1px solid ${theme.colors.primary};
              `
            : null}
`;
